import header from './header';
import footer from './footer';

export default {
  loading: 'Завантаження повідомлень...',
  empty: 'Немає повідомлень',
  chat_not_select: 'Обрати чат',

  no_more_message: 'No more message',

  status: {
    new: 'Новий',
    chat: 'Чат',
    resolved: 'Вирішено',
  },

  message_email: {
    add: 'Зберегти як контакт\Email контакту',
  },

  play_video: 'Відтворити відео',
  download_file: 'Завантажити файл',

  header,
  footer,
};
